
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker, createStaticRanges, defaultStaticRanges } from 'react-date-range';
import { useEffect, useRef, useState } from 'react';
import "../../../components/common/styles.scss";

const EmailCustomDate = ({ dateRange, setDateRange }) => {
    const [errorMessage, setErrorMessage] = useState("");

    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const calendarRef = useRef(null);

    const handleSelect = (ranges: any) => {
        const { startDate, endDate } = ranges.selection;
        const today = new Date();
        // Ensure endDate is not after today
        const validEndDate = endDate > today ? today : endDate;
        // Calculate difference in days
        const diffTime = Math.abs(validEndDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // inclusive
        if (diffDays > 7) {
            setErrorMessage("Please select a date range of 7 days or less.");
            return;
        }
        setErrorMessage("");
        setDateRange([
            {
                startDate,
                endDate: validEndDate,
                key: "selection",
            },
        ]);
    };

    const toggleCalendar = () => {
        setIsCalendarOpen(!isCalendarOpen);
    };

    const handleClickOutside = (event: any) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target)) {
            setIsCalendarOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const formatDate = (date: any) => {
        return date.toLocaleDateString("en-GB");
    };

    const staticRanges = createStaticRanges(
        defaultStaticRanges.filter(
            (range) => range.label !== "This Month" && range.label !== "Last Month"
        )
    );

    return (
        <div style={{ position: "relative" }}>
            <div style={{ position: "absolute", top: "-9px", left: "5px", background: "white" }}><p style={{ margin: "0" }}>Select Date</p></div>
            <div onClick={toggleCalendar} style={{ border: "1px solid #ccc", padding: " 9px", borderRadius: "4px", cursor: "pointer", overflow: "hidden", fontSize: "11px" }}>
                {`${formatDate(dateRange[0].startDate)} - ${formatDate(dateRange[0].endDate)}`}
            </div>
            {isCalendarOpen && (
                <div
                    ref={calendarRef}
                    style={{
                        position: "absolute",
                        zIndex: 1000,
                        padding: "5px",
                        right: 0 // Added to move the date picker to the left side of the container
                    }}
                >
                    <DateRangePicker
                        editableDateInputs={true}
                        onChange={handleSelect}
                        moveRangeOnFirstSelection={false}
                        ranges={dateRange}
                        staticRanges={staticRanges}
                        maxDate={new Date()} // Prevent selecting a date after today
                    />
                </div>
            )}
            {errorMessage && (
                <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{errorMessage}</div>
            )}
        </div>
    );
};

export default EmailCustomDate;